// Common
import { ReactElement, useCallback } from 'react'
import { useHistory } from 'react-router-dom'

// Styles
import { makeStyles } from '@material-ui/styles'

// Icons
import DoneIcon from 'components/svg-icons/done'

// Commponents
import Column from 'shared-components/col'
import { Button } from '@material-ui/core'
import Typography from 'shared-components/typography'

const useStyle = makeStyles({
	body: {
		backgroundColor: '#fff',
		flex: 1,
		alignItems: 'center !important',
		margin: 'auto',
		width: '100%',
		height: '100vh',
	},
	button: {
		border: '1px solid #73C21E',
		width: '170px',
		fontSize: '18px',
		fontWeight: 600,
		color: '#73C21E',
		textTransform: 'none',
	},
})

export default function Done(): ReactElement {
	const classes = useStyle()
	const history = useHistory()

	const handleClick = useCallback(() => {
		history.push('/')
		sessionStorage.clear()
	}, [history])

	return (
		<Column className={classes.body}>
			<DoneIcon style={{ width: 74, height: 74}}/>
			<Typography
				fontWeight='400'
				style={{marginTop: '24px', marginBottom: '33px', fontSize: '18px', padding: '0 20px', textAlign: 'center'}}
			>
				Thanks for sharing your property details.
				We will reach out to you soon.
			</Typography>
			<Button
				onClick={handleClick}
				className={classes.button}
				disableRipple
				disableFocusRipple
			>
				Done
			</Button>
		</Column>
	)
}
